import { InMemoryCache } from '@apollo/client';

const buildGraphQLApiCache = () =>
  new InMemoryCache({
    typePolicies: {
      ShopProductVariant: {
        keyFields: ['sku'],
      },
      Color: {
        keyFields: ['uniqueColorId'],
      },
    },
  });

export default buildGraphQLApiCache;
